import { render, staticRenderFns } from "./AddUserTab.vue?vue&type=template&id=5188915a"
import script from "./AddUserTab.vue?vue&type=script&lang=js"
export * from "./AddUserTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports